import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  showScroll: Boolean = false;
  scroll = 562;

  constructor() { }
  @HostListener('window:scroll', ['$event']) onScroll(event) {
    if (window.scrollY >= this.scroll) {
      this.showScroll = true;
    } else {
      this.showScroll = false;
    }
  }

  ngOnInit(): void {
  }

}
